module.exports = __webpack_public_path__ + "img/fotos_mobile.e633302b.png";